import { render, staticRenderFns } from "./historical-order-detail-inquiry.vue?vue&type=template&id=f28b1282&scoped=true&"
import script from "./historical-order-detail-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-order-detail-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-order-detail-inquiry.vue?vue&type=style&index=0&id=f28b1282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28b1282",
  null
  
)

export default component.exports